import type { Role } from '@core/entities/Role';
import type { RoleRepository } from '@core/repositories/RoleRepository';
import { httpClient } from '@infrastructure/http/httpClient';
import { toAppError } from '@infrastructure/http/errorMapper';

interface RoleEnvelope {
  data: Role[];
}

export class RoleRepositoryImpl implements RoleRepository {
  async list(): Promise<Role[]> {
    try {
      const response = await httpClient.get<RoleEnvelope>('/roles');
      return response.data.data;
    } catch (error) {
      throw toAppError(error);
    }
  }
}
